'use client';

import {
    ContactGeneralOpeningHoursFrame,
    ContactRootFrame, ContactSpecialOpeningHoursFrame
} from "@/app/features/sites/contact/ui/shared/ContactFrames";
import ContactMap from "@/app/__to_be_integrated/_____components/map/ContactMap";
import ContactView from "@/app/__to_be_integrated/_____components/_NEW/contact/ContactView";
import GeneralOpeningHoursView
    from "@/app/__to_be_integrated/_____components/_NEW/opening-hours/GeneralOpeningHoursView";
import {Typography } from "@mui/material";
import SpecialOpeningHoursView
    from "@/app/__to_be_integrated/_____components/_NEW/opening-hours/SpecialOpeningHoursView";
import EditorHint from "@/app/features/shared/editor-hint/EditorHint";
import { useSiteContactEditor } from "@/app/features/sites/contact/contexts/ContactEditorContext";


export default function ContactEditable() {

    const {
        contact,
        generalOpeningHours,
        specialOpeningHours
    } = useSiteContactEditor();

    return (
        <ContactRootFrame
            mapChildren={<ContactMap contact={contact} />}
            contentChildren={
                <>
                    <EditorHint route={{ url: "/admin/contact" }}>
                        <ContactView contact={contact!} />
                    </EditorHint>

                    <ContactGeneralOpeningHoursFrame>
                        <EditorHint route={{ url: "/admin/special-opening-hours" }}>
                            <GeneralOpeningHoursView generalOpeningHours={generalOpeningHours!} />
                        </EditorHint>
                    </ContactGeneralOpeningHoursFrame>

                    <ContactSpecialOpeningHoursFrame
                        title={
                            <Typography variant="h4" sx={{ alignSelf: 'flex-start', marginTop: 4 }}>Sonderöffnungszeiten & Schließtage</Typography>
                        }
                    >
                        <EditorHint route={{ url: "/admin/special-opening-hours" }}>
                            <SpecialOpeningHoursView specialOpeningHours={specialOpeningHours} />
                        </EditorHint>
                    </ContactSpecialOpeningHoursFrame>
                </>
            }
        />
    )
}
